export default __webpack_public_path__ + "static/media/sports-icon-active.29dd3b18.webp";